import type { MissionAccountingPage_AccountingInfo } from '../../../pages/MissionAccounting/fragments/accounting-info.fragment';

export enum AccountingContextStatus {
  Loading = 'loading',
  NotInitialized = 'notInitialized',
  Ready = 'ready',
  Error = 'error',
}

interface AccountingContextLoading {
  readonly status: AccountingContextStatus.Loading;
  readonly missionAccountingInfo: undefined;
}

interface AccountingContextNotInitialized {
  readonly status: AccountingContextStatus.NotInitialized;
  readonly missionAccountingInfo: undefined;
}

interface AccountingContextReady {
  readonly status: AccountingContextStatus.Ready;
  readonly missionAccountingInfo: MissionAccountingPage_AccountingInfo;
}

interface AccountingContextError {
  readonly status: AccountingContextStatus.Error;
  readonly missionAccountingInfo: undefined;
}

export type AccountingContextData =
  | AccountingContextLoading
  | AccountingContextNotInitialized
  | AccountingContextReady
  | AccountingContextError;
